(() => {

    let container = document.querySelector('.texture-list')

    if(container) {

        let trigger = container.querySelector('.texture-list--label')
        let list = container.querySelector('.texture-list--links')

        trigger.addEventListener('click', () => {
            list.classList.toggle('open')
        })
    }
})()
